<template>
  <div>
    <div class="header container-fluid mt-3">
      <div class="row">
        <div class="col-xl-12" v-if="encontrado">
          <div
            class="card row justify-content-center mt-4"
            style="min-height: 180px; max-width: 315px; margin: 0 auto"
          >
            <div class="card-body pt-3">
              <div class="row">
                <div class="col-lg-12">
                  <h4 class="row justify-content-center">
                    {{ activo.modelo.fabricante.nombre }}
                    {{ activo.modelo.nombre }}
                  </h4>
                  <h4 class="row justify-content-center">
                    {{ activo.empresa.razonSocial }}
                  </h4>
                  <div class="row justify-content-center">
                    <img
                      :src="activo.modelo.imagen.url"
                      class="rounded-circle"
                      style="max-height: 170px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="card row justify-content-center mt-4"
            style="max-width: 315px; margin: 0 auto; border: 2px solid green"
            v-if="activo.estadoRevision == 'Apto'"
          >
            <div class="card-body pt-3">
              <div class="row">
                <div class="col-lg-12 pt-3">
                  <div class="row justify-content-center">
                    <img
                      src="/img/ios-checkmark-circle.png"
                      style="height: 72px; width: 72px"
                    />
                  </div>
                  <h4 class="row justify-content-center pt-4">
                    Equipo APTO para su uso
                  </h4>
                  <h5
                    class="row justify-content-center"
                    v-if="ultimaRevision && ultimaRevision.fecha_revision"
                  >
                    <span class="status">
                      Fecha de revisión:
                      {{
                        moment(ultimaRevision.fecha_revision).format(
                          "DD/MM/YYYY"
                        )
                      }}
                      ({{ moment(ultimaRevision.fecha_revision).fromNow() }})
                    </span>
                  </h5>
                  <h5 class="row justify-content-center">
                    <span class="status"
                      >Próx. revisión:
                      {{
                        moment(activo.fecha_prox_revision).format("DD/MM/YYYY")
                      }}
                      ({{ moment(activo.fecha_prox_revision).fromNow() }})</span
                    >
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div
            class="card row justify-content-center mt-4"
            style="max-width: 315px; margin: 0 auto; border: 2px solid red"
            v-else
          >
            <div class="card-body pt-3">
              <div class="row">
                <div class="col-lg-12 pt-3">
                  <div class="row justify-content-center">
                    <img
                      src="/img/ios-alert.png"
                      style="height: 72px; width: 72px"
                    />
                  </div>

                  <h4 class="row justify-content-center pt-4">
                    Equipo NO APTO para su uso
                  </h4>
                  <h5
                    class="row justify-content-center"
                    v-if="ultimaRevision && ultimaRevision.fecha_revision"
                  >
                    <span class="status">
                      Fecha de revisión:
                      {{
                        moment(ultimaRevision.fecha_revision).format(
                          "DD/MM/YYYY"
                        )
                      }}
                      ({{ moment(ultimaRevision.fecha_revision).fromNow() }})
                    </span>
                  </h5>
                  <h5
                    class="row justify-content-center"
                    v-if="activo.estadoRevision !== 'No apto'"
                  >
                    <span class="status"
                      >Próx. revisión:
                      {{
                        moment(activo.fecha_prox_revision).format("DD/MM/YYYY")
                      }}
                      ({{ moment(activo.fecha_prox_revision).fromNow() }})</span
                    >
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row justify-content-center mt-4"
            style="max-width: 315px; margin: 0 auto"
            v-if="activo.estadoRevision == 'Caducado'"
          >
            <base-button
              outline
              type="primary"
              @click="modals.form = true"
              style="width: 100%"
              >Solicitar revisión</base-button
            >
          </div>
        </div>
      </div>
      <!--Form modal-->
      <modal :show.sync="modals.form" size="sm" body-classes="p-0">
        <card
          type="secondary"
          header-classes="bg-transparent pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0 mb-0"
        >
          <template>
            <div class="text-center text-muted mb-4">
              <small
                >Póngase en contacto con el equipo de Misepis para poder tener
                acceso a muchas más funcionalidades</small
              >
            </div>
            <form role="form">
              <base-input alternative placeholder="Mensaje">
                <textarea
                  class="form-control"
                  v-model="message"
                  rows="4"
                  placeholder="Mensaje"
                ></textarea>
              </base-input>

              <a
                :href="
                  'mailto:' +
                  emailAddress +
                  '?subject=Contacto Misepis&body=' +
                  bodyToSend
                "
              >
                <div class="text-center">
                  <base-button outline type="primary" style="width: 100%"
                    >Enviar</base-button
                  >
                </div></a
              >
            </form>
          </template>
        </card>
      </modal>
    </div>
  </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import moment from "moment";
import axios from "axios";
import "moment/locale/es"; // without this line it didn't work
moment.locale("es");
const url = process.env.VUE_APP_API_BASE_URL;

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  mixins: [formMixin],

  data() {
    return {
      encontrado: false,
      initial: true,
      image: "",
      file: null,
      available_empresas: [],
      available_divisiones: [],
      available_tipos: [],
      available_subtipos: [],
      available_fabricantes: [],
      available_modelos: [],
      modals: {
        form: false,
      },
      emailAddress: "aconde@delfrom.com",

      activo: null,
    };
  },
  created() {
    this.initial = true;
    this.findOneByQR();
  },

  computed: {
    ultimaRevision() {
      if (
        !this.activo ||
        !this.activo.revisiones ||
        this.activo.revisiones.length === 0
      ) {
        return null;
      }
      return this.activo.revisiones[this.activo.revisiones.length - 1];
    },
  },
  watch: {
    message(val) {
      this.bodyToSend = val.replaceAll("\n", "%0D");
    },
  },
  methods: {
    async get() {
      try {
        const code = this.$route.params.code;

        console.log(code);

        let params = {
          filters: {
            ...{
              numero_serie_qr: { $eq: code },
            },
          },
          pagination: {
            page: 1,
            pageSize: 1,
          },
        };
        await this.$store.dispatch("activos/listCode", code).then(() => {
          var activos = this.$store.getters["activos/listCode"];

          if (activos.length > 0) {
            this.asset = activos[0];

            console.log(this.asset);
            this.encontrado = true;
          } else {
            this.$notify({
              type: "danger",
              message: `No existe ningún equipo con ese código`,
            });
          }
        });

        /*  await this.$store.dispatch("activos/get", id);
        this.asset = this.$store.getters["activos/activo"];

        console.log(this.asset); */
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        console.log(error);
        this.setApiValidation(error.response.data.errors);
      }
    },
    async findOneByQR() {
      try {
        const code = this.$route.params.code;
        console.log("QR: ", code);

        await axios
          .get(`${url}/activos/qr/${code}`)
          .then((response) => {
            this.activo = response.data;
            console.log("ACTIVO: ", this.activo);
            this.encontrado = true;
          })
          .catch((error) => {
            console.error("Error fetching activo details:", error);
            this.$notify({
              type: "danger",
              message: `No existe ningún equipo con ese código`,
            });
          });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, algo ha ido mal!`,
        });
        console.log(error);
        this.setApiValidation(error.response.data.errors);
      }
    },
  },
};
</script>
<style>
.profile-header {
  background-image: url(/img/theme/profile-cover.jpg);
  background-size: cover;
  background-position: center top;
  min-height: 500px;
}
</style>
